module.exports = __webpack_public_path__ + "1267cd0fe2dd85b785618ce68703886c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-light.svg
// module id = 1571
// module chunks = 0